import { Box, Button, Paper, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MyListApi } from "../utils/restApi";
import { notification } from "../utils/utils";
import { useSelector } from "react-redux";
import { ItemPropertyImage } from "./ItemPropertyImage";
import { ItemPropertyLocation } from "./ItemPropertyLocation";

export const ItemUpdate = props => {

    const user = useSelector(state => state.login.user);
    const { itemUpdateId } = useParams();
    const [update, setUpdate] = useState(null);
    const [item, setItem] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!error && !update) {
            MyListApi.getItemUpdate(itemUpdateId)
                .then(data => setUpdate(data))
                .catch(error => setError(error));
        }
        if (!error && !item && update) {
            MyListApi.getItem(update.itemId)
                .then(data => setItem(data))
                .catch(error => setError(error));
        }
    }, [update, item, error]);

    if (!item || !update) {
        return <Box></Box>;
    }

    const data = item ? JSON.parse(item.data) : null;
    const dataInfo = (JSON.parse(item.tag.dataInfo) || []).find(di => di.name === update.property);

    const handleCancel = () => {
        navigate(`/items/${item.id}`);
    }

    const handleInvalid = () => {
        navigate(`/items/${item.id}`);
        MyListApi.itemUpdateVote(update.id, false)
            .then(data => {
                notification("Item update successfully indicated as invalid.", "success");
            })
            .catch(error => {
                notification(error.message, "error");
            });
    }

    const handleValid = () => {
        navigate(`/items/${item.id}`);
        MyListApi.itemUpdateVote(update.id, true)
            .then(data => {
                notification("Item update successfully indicated as valid.", "success");
            })
            .catch(error => {
                notification(error.message, "error");
            });
    }

    const handleAccept = () => {
        MyListApi.itemUpdateApply(update?.id, true)
            .then(data => {
                navigate(`/items/${item.id}`);
                notification("All good", "success");
            })
            .catch(error => {
                notification(error.message, "error");
            });
    }

    const handleReject = () => {
        MyListApi.itemUpdateApply(update?.id, true)
            .then(data => {
                navigate(`/items/${item.id}`);
                notification("All good", "success");
            })
            .catch(error => {
                notification(error.message, "error");
            });
    }

    const prevValue = update ? data[`${update?.property}`] : null;
    const newValue = update?.value;

    const prevValueElement = {
        ['image']: <ItemPropertyImage image={prevValue} />,
        ['location']: <ItemPropertyLocation coords={prevValue} />,
    };

    const newValueElement = {
        ['image']: <ItemPropertyImage image={newValue} />,
    }

    return (
        <Paper sx={{ padding: '20px' }}>
            {(item && update) ?
                <Box>
                    <Typography variant="h4">Item Update</Typography>
                    <Typography>Item property has existing update. This must be resolved before another update is created. Please choose to accept or reject the current update.</Typography>
                    <Typography variant="h6">{update.property}</Typography>
                    <Typography fontWeight="bold">Previous Value</Typography>
                    {prevValueElement[`${dataInfo?.type}`] || <Typography>{prevValue}</Typography>}
                    <Typography fontWeight="bold">New Value</Typography>
                    {newValueElement[`${dataInfo?.type}`] || <Typography>{newValue}</Typography>}
                    <Typography>Accepted: {update.applyCount}</Typography>
                    <Typography>Rejected: {update.rejectCount}</Typography>
                    <Box sx={{ display: 'flex', gap: '10px' }}>
                        <Button variant="contained" onClick={handleCancel}>Cancel</Button>
                        <Button variant="contained" onClick={handleInvalid}>Invalid</Button>
                        <Button variant="contained" onClick={handleValid}>Valid</Button>
                    </Box>
                    {user.isAdmin ?
                        <Box>
                            <Typography variant="h6">Admin</Typography>
                            <Button onClick={handleAccept}>Accept</Button>
                            <Button onClick={handleReject}>Reject</Button>
                        </Box>
                    : null}
                </Box>
            : null}
        </Paper>
    );
}